import React from 'react';
import { palette } from '../../../utils/designTokens';
import { feedbackIconStyle } from './rcaHelpers';
import { FeedbackGlyph, Section } from './RcaPrimitives';

export default function FeedbackPanel({
  rca,
  busy,
  onFeedback,
  onThumbsDown,
  onResolution,
  showFeedback = true,
  showResolution = true,
}) {
  const currentVote = rca?.feedback?.current_user_vote || '';
  const resolved = rca?.status === 'resolved';
  return (
    <Section title="Review">
      <div className="flex flex-wrap gap-2">
        {showFeedback && (
          <>
            <button
              type="button"
              title="Thumbs up"
              aria-label="Thumbs up"
              disabled={busy}
              className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-xs font-medium hover:bg-background-tertiary disabled:opacity-50"
              style={feedbackIconStyle(currentVote === 'thumbs_up', palette.status.success)}
              onClick={() => onFeedback('thumbs_up')}
            >
              <FeedbackGlyph type="up" active={currentVote === 'thumbs_up'} size={15} />
              <span>{rca?.feedback?.thumbs_up || 0}</span>
            </button>
            <button
              type="button"
              title="Thumbs down"
              aria-label="Thumbs down"
              disabled={busy}
              className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-xs font-medium hover:bg-background-tertiary disabled:opacity-50"
              style={feedbackIconStyle(currentVote === 'thumbs_down', palette.status.danger)}
              onClick={onThumbsDown}
            >
              <FeedbackGlyph type="down" active={currentVote === 'thumbs_down'} size={15} />
              <span>{rca?.feedback?.thumbs_down || 0}</span>
            </button>
          </>
        )}
        {showResolution && (
          !resolved ? (
            <button
              type="button"
              disabled={busy}
              className="rounded border border-border-subtle px-3 py-1.5 text-xs text-text-primary hover:bg-background-tertiary disabled:opacity-50"
              onClick={() => onResolution(true)}
            >
              Mark resolved
            </button>
          ) : (
            <span className="rounded border border-border-subtle px-3 py-1.5 text-xs text-text-muted">
              Resolved
            </span>
          )
        )}
      </div>
    </Section>
  );
}
